import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './CommissionTransactionsTableHead.scss';

export const COMMISSION_TRANSACTIONS_TABLE_HEADER = [
  {
    label: 'transactionNumber'
  },
  {
    label: 'createdAt',
    sortBy: 'created_at'
  },
  {
    label: 'transferProvider',
    sortBy: 'transfer_provider'
  },
  {
    label: 'transactionType',
    sortBy: 'type'
  },
  {
    label: 'amount',
    sortBy: 'amount'
  },
  {
    label: 'currency',
    sortBy: 'currency'
  },
  {
    label: 'senderName',
    sortBy: 'sender_name'
  },
  {
    label: 'recipientName',
    sortBy: 'recipient_name'
  },
  {
    label: 'comment',
    sortBy: 'comment'
  }
];

const CommissionTransactionsTableHead = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {COMMISSION_TRANSACTIONS_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'commission-transactions-table-head'}>
              <div className={'commission-transactions-table-head-block'}>
                <span>{i18n.getMessage(`commissions.commissionTransactions.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`commission-transactions-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

CommissionTransactionsTableHead.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default CommissionTransactionsTableHead;
